import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import StatusCode from 'status-code-enum';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { GetPBLData, IGetPBLDataRequest, IGetPBLDataResponse } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetPBLDataApi =
  (endpoint: string): GetPBLData =>
  async (request: IGetPBLDataRequest) => {
    try {
      const { requestId, custId, pin } = request;
      const _requestId = parseInt(requestId);
      LogCannon.blast('GetPBLDataApi start', {
        endpoint,
        requestId: _requestId,
        custId,
        pin,
      });
      const scenario = CookieHelper.getCookie('scenario');
      const config = createAxiosConfig(scenario, endpoint);
      const response = await axios.post(endpoint, { requestId: _requestId, custId, pin }, config);
      LogCannon.blast('GetPBLDataApi success');
      return Promise.resolve({ ...response.data, customerId: custId } as IGetPBLDataResponse);
    } catch (error: any) {
      /*
        422 = Invalid pbl data
        404 = pbl data doesn't exist
      */
      if (error.response) {
        LogCannon.error('GetPBLDataApi error', { error: error.response.data?.message });
        if (
          error.response.status === StatusCode.ClientErrorUnprocessableEntity ||
          error.response.status === StatusCode.ClientErrorNotFound
        ) {
          return Promise.reject({
            message: 'This session has expired or cannot be located. Please try again',
            requestId: error.response.data?.requestId,
            type: ErrorType.PBL_EXPIRED,
          });
        } else if (error.response.status === StatusCode.ClientErrorUnauthorized) {
          return Promise.reject({
            message: 'User pin does not match EPC pin',
            requestId: error.response.data?.requestId,
            type: ErrorType.PBL_INCORRECT_PIN,
          });
        } else if (error.response.status === StatusCode.ClientErrorForbidden) {
          return Promise.reject({
            message: 'Too many failed pin attempts',
            requestId: error.response.data?.requestId,
            type: ErrorType.PBL_TOO_MANY_ATTEMPTS,
          });
        } else {
          return Promise.reject({
            message: error.response.data?.message,
            requestId: error.response.data?.requestId,
            type: ErrorType.SYSTEM_ERROR,
          });
        }
      } else {
        LogCannon.error('GetPBLDataApi error', { error });
        return Promise.reject({
          message: error,
        });
      }
    }
  };
